(function() {
    'use strict';

    angular
        .module('liverunApp')
        .controller('ScoreDeleteController',ScoreDeleteController);

    ScoreDeleteController.$inject = ['$uibModalInstance', 'entity', 'Score'];

    function ScoreDeleteController($uibModalInstance, entity, Score) {
        var vm = this;

        vm.score = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Score.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
